// extracted by mini-css-extract-plugin
export var activeTab = "tabbed-content-module--activeTab--82f79";
export var fadeIn = "tabbed-content-module--fadeIn--3abfd";
export var fadeOut = "tabbed-content-module--fadeOut--6df52";
export var moduleContainer = "tabbed-content-module--moduleContainer--aabc1";
export var pinTabsToTop = "tabbed-content-module--pinTabsToTop--cdfe8";
export var tabContainer = "tabbed-content-module--tabContainer--06a1b";
export var tabsContainer = "tabbed-content-module--tabsContainer--182e7";
export var tabsContainerWrapper = "tabbed-content-module--tabsContainerWrapper--a3675";